import React from 'react';
import Modal from 'react-modal';


export const handleOnRequestClose = (onRequestClose, setAgendaDivHeight, setMsgDivHeight, setAttendeesDivHeight) => {
    onRequestClose(onRequestClose, setAgendaDivHeight, setMsgDivHeight, setAttendeesDivHeight);
    if (setAgendaDivHeight) setAgendaDivHeight(false);
    if (setMsgDivHeight) setMsgDivHeight(false);
    if (setAttendeesDivHeight) setAttendeesDivHeight(false);
};


const UpcomingMeetingModal = ({
    isOpen,
    onRequestClose,
    customStyles,
    fullView,
    setFullView,
    setAgendaDivHeight,
    setMsgDivHeight,
    setAttendeesDivHeight,
    attendeesDivHeight,
    agendaDivHeight,
    msgDivHeight,
    stripHtmlTags
}) => {




    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={() => handleOnRequestClose(onRequestClose, setAgendaDivHeight, setMsgDivHeight, setAttendeesDivHeight)}
            shouldCloseOnOverlayClick={false}
            style={customStyles}
        >
            <div className="inner-upcoming-meet-detail-modal">
                <div
                    className="tb-modal-close-btn"
                    data-testid="crossButton"
                    onClick={() => {
                        onRequestClose(onRequestClose, setAgendaDivHeight, setMsgDivHeight, setAttendeesDivHeight);
                        setAgendaDivHeight(false);
                        setMsgDivHeight(false);
                        setAttendeesDivHeight(false);
                    }}
                >
                    <span>X</span>
                </div>
                <div className="view-modal-type-tag">
                    <div className="view-model-typeofmeet-tag-inner">{fullView?.typeOfMeeting} Meeting</div>
                </div>
                <div className="UPM-view-modal-info-cont">
                    <div
                        className="UPM-Modal-sub-name"
                        style={{
                            fontSize: '21px',
                            textTransform: 'capitalize',
                            marginBottom: '10px',
                            marginTop: '10px'
                        }}
                    >
                        <h3 style={{ fontSize: '21px', textTransform: 'capitalize' }}>
                            {fullView?.data?.title}
                        </h3>
                    </div>
                    <div className="UPM-view-modal-row">
                        <div style={{ display: 'flex' }}>
                            <div className="label-title2">
                                <p>From</p> <span>:</span>
                            </div>
                            <div className="label-value2">{fullView?.data?.Ownername}</div>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <div className="label-title2">
                                <p>Location</p> <span>:</span>
                            </div>
                            <div className="label-value2">{fullView?.data?.Location}</div>
                        </div>
                    </div>
                    <div className="UPM-view-modal-row">
                        <div style={{ display: 'flex' }}>
                            <div className="label-title2">
                                <p>Start Date</p> <span>:</span>
                            </div>
                            <div className="label-value2">{fullView?.data?.startDate}</div>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <div className="label-title2">
                                <p>End Date</p> <span>:</span>
                            </div>
                            <div className="label-value2">{fullView?.data?.endDate}</div>
                        </div>
                    </div>
                    <div className="UPM-view-modal-row">
                        <div style={{ display: 'flex' }}>
                            <div className="label-title2">
                                <p>Start Time</p> <span>:</span>
                            </div>
                            <div className="label-value2">{fullView?.data?.startTime}</div>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <div className="label-title2">
                                <p>End Time</p> <span>:</span>
                            </div>
                            <div className="label-value2">
                                {fullView?.data?.endTime === '11:59 PM'
                                    ? '12:00 AM'
                                    : fullView?.data?.endTime}
                            </div>
                        </div>
                    </div>
                    <div className="UPM-view-modal-row2">
                        <div className="label-title">
                            <p>Attendees</p>
                            <span>:</span>
                        </div>
                        <div>
                            <div
                                className={fullView.viewMoreAttendees ? 'attendeescont' : 'attendeesEllipses'}
                                id="attendees_div"
                            >
                                {fullView?.data?.attendees?.map((item, index) => (
                                    <span style={{ fontSize: '13px' }} key={index}>
                                        {item}
                                        {index + 1 === fullView?.data?.attendees.length ? '' : ','}
                                    </span>
                                ))}
                            </div>
                            {attendeesDivHeight && (
                                <div className="read-more attendeesViewmorebtn">
                                    <button
                                        style={{
                                            border: 'none',
                                            backgroundColor: 'transparent',
                                            textDecoration: 'underline',
                                            color: '#00ADEE'
                                        }}
                                        data-testid="attendeesViewmorebtn1"
                                        onClick={() =>
                                            setFullView((prevState) => ({
                                                ...prevState,
                                                viewMoreAttendees: !prevState.viewMoreAttendees
                                            }))
                                        }
                                    >
                                        <span>{fullView.viewMoreAttendees ? ' View less' : 'View more '}</span>
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="UPM-view-modal-row2">
                        <div className="label-title">
                            <p>Agenda</p>
                            <span>:</span>
                        </div>
                        <div style={{ paddingLeft: '3%' }}>
                            {!(stripHtmlTags(fullView?.data?.agenda ? fullView?.data?.agenda[0] : [] || '')?.trim()?.length === 0 ||
                                fullView?.data?.agenda.length === 0) ? (
                                <div
                                    id="agenda_div"
                                    dangerouslySetInnerHTML={{ __html: fullView?.data?.agenda }}
                                    className={fullView.viewMore === false ? 'addEllipses' : 'removeEllipses'}
                                    style={{ width: '100%', fontSize: '13px' }}
                                ></div>
                            ) : (
                                <div style={{ fontSize: '13px', color: 'black' }}>Not Available</div>
                            )}
                            {agendaDivHeight && (
                                <div className="read-more">
                                    <button
                                        style={{
                                            border: 'none',
                                            backgroundColor: 'transparent',
                                            textDecoration: 'underline',
                                            color: '#00ADEE'
                                        }}
                                        data-testid="attendeesViewmorebtn2"
                                        onClick={() =>
                                            setFullView((prevState) => ({
                                                ...prevState,
                                                viewMore: !prevState.viewMore
                                            }))
                                        }
                                    >
                                        {fullView.viewMore ? ' View less' : 'View more '}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                    {!(stripHtmlTags(fullView?.data?.Msg || '')?.trim()?.length === 0 ||
                        fullView?.data?.Msg === '<p><br></p>') && (
                            <div className="UPM-view-modal-row2">
                                <div className="label-title">
                                    <p>Message</p>
                                    <span>:</span>
                                </div>
                                <div
                                    id="message_div"
                                    dangerouslySetInnerHTML={{ __html: fullView?.data?.Msg }}
                                    className={fullView.viewMoreMsg ? '' : 'msgbox'}
                                    style={{ fontSize: '13px', paddingLeft: '3%' }}
                                ></div>
                            </div>
                        )}
                    {msgDivHeight && (
                        <div className="read-more-msg">
                            <button
                                style={{
                                    border: 'none',
                                    backgroundColor: 'transparent',
                                    textDecoration: 'underline',
                                    color: '#00ADEE',
                                    marginTop: '-11px'
                                }}
                                data-testid="attendeesViewmorebtn3"
                                onClick={() =>
                                    setFullView((prevState) => ({
                                        ...prevState,
                                        viewMoreMsg: !prevState.viewMoreMsg
                                    }))
                                }
                            >
                                {fullView.viewMoreMsg ? 'View less ' : ' View more'}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default UpcomingMeetingModal;
